module.exports = __webpack_public_path__ + "static/media/Nokia C3-00.265f0ac1.png";